import EventEmitter, { EventEmitterCallback } from "./EventEmitter";

const listeners = {};
const TEST_KEY = '__TEST__';
const eventEmitter = new EventEmitter();

const detect = () => {
  try {
    const ls = window.localStorage;
    ls.setItem(TEST_KEY, TEST_KEY);
    ls.removeItem(TEST_KEY);
    return true;
  } catch (e) {
    return false;
  }
};

const change = (key: string, value: any) => {
  const { events } = eventEmitter
  if (Array.isArray(events.all)) {
    events.all.forEach(cb => cb(value, key));
  }
  if (Array.isArray(events[key])) {
    events[key].forEach(cb => cb(value, key));
  }
};

const onStorage = (e: StorageEvent) => {
  const { key, newValue } = e;
  if (newValue === null) return;
  let value;
  try {
    value = JSON.parse(newValue);
  } catch (e) {
    value = newValue;
  }
  if (key === TEST_KEY) return;
  change(key, value);
};

const supported = detect();
if (supported) {
  window.addEventListener('storage', onStorage);
}

export const listen = (key: string, callback: EventEmitterCallback) => eventEmitter.on(key, callback);

export const broadcast = (key: string, value: any) => {
  if (supported) {
    const strValue = typeof value !== 'string' ? JSON.stringify(value) : value;
    const ls = window.localStorage;
    ls.setItem(key, strValue);
    ls.removeItem(key);
  }
  change(key, value);
};
